module.exports = __webpack_public_path__ + "static/img/gywm.15a7cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gywm.png
// module id = e24Z
// module chunks = 4